export { default } from "./SkeletonManageContainer";
